import { useIntegrationsDomainContext } from 'Integrations/communication'

export const useIntegrationsBrowserModal = () => {
  const ctx = useIntegrationsDomainContext()

  return {
    loading: !ctx.queries.rawData.editor.loaded
  }
}
